/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React from 'react'
import styled from '@emotion/styled'
import { AutoSizer } from 'react-virtualized'
import { message } from 'antd'
export const CriteriaRow = styled.div`
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: 16px 16px;
`

export const Content = styled.div`
  margin-top: 24px;
  background-color: #fff;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 24px;
  min-width: 780px;
  padding-top: 15px;
`

export const Controls = styled.div`
  display: flex;
  padding: 24px 0px;
  align-items: center;
`

export const Filler = styled.div`
  flex: 1 1 0px;
`

export const Title = styled.span`
  white-space: nowrap;
  overflow: hidden;
  font-size: 1.4em;
  color: #000;
`

export const FullHeightSizer = ({
  className,
  style,
  heightOffset = 0,
  children,
  containerStyle = {},
  widthOffset = 0,
}) => (
  <div
    className={className}
    style={style}
    css={{ height: `calc(100vh - ${heightOffset}px)` }}
  >
    <AutoSizer>
      {({ height, width }) => (
        <div
          css={{
            ...containerStyle,
            width: `${width - widthOffset}px`,
            height: `${height}px`,
          }}
        >
          {children({ width, height })}
        </div>
      )}
    </AutoSizer>
  </div>
)

export const NoDataIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #777;
  font-weight: bold;
  font-size: 1.5em;
  height: 100%;
`
export const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`

export const dataSavedMessage = _ => message.info('Data saved successfully.')
